export default __webpack_public_path__ + "static/media/data1.4cb1de34.png";